.ux-iws-search-results {
    @include clearfix();
    display: block;

    &__inner {
        flex: 1 1 auto;

        @media only screen and (min-width: 568px) {
            margin-top: 10px;
        }

        @media only screen and (min-width: 1440px) {
            margin-top: 25px;
        }
    }

    &__header-row {
        min-height: 44px;
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 5px;
    }

    &__filter-container {
        @include clearfix();
    }

    &__filter-row {
        margin-left: -8px;
        margin-right: -8px;
        width: auto;
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
    }

    &__filter-container {
        margin-top: 15px;

        @media only screen and (min-width: 1024px) {
            margin-top: 10px;
        }

        @media only screen and (min-width: 1440px) {
            margin-top: 5px;
        }
    }

    &__filter-container form {
        @media only screen and (min-width: 1440px) {
            margin-bottom: 25px;
        }
    }

    &__filter-dropdown {
        flex: 0 0 auto;
        padding: 0 8px;
        margin-bottom: $dim-15;
        width: 100%;

        .ux-dropdown__list {
            padding-bottom: $dim-15;
        }

        @media (min-width: 769px) {
            width: 50%;
        }

        @media (min-width: 1025px) {
            width: 33.333%;
        }

        @media (min-width: 1281px) {
            width: 25%;
        }
    }

    &__sort {
        margin-bottom: 0;
    }

    &__summary {
        .ux-text-link {
            font-size: $size-text-normal;
        }
    }

    &__results-container {
        margin-top: 20px;

        @media only screen and (min-width: 1024px) {
            margin-top: 25px;
        }

        .swiper-button-disabled {
            display: none;
        }

        [rel="results-summary"] {
            display: none;
        }
    }

    &__results-container--all-results {
        margin-top: 5px;

        @media only screen and (min-width: 1440px) {
            margin-top: 40px;
        }

        .ux-iws-search-results__header-row {
            margin-bottom: 0;
        }
    }

    ux-tag {
        height: $dim-30;
        margin: 0;
    }

    .ux-tag-list {
        &__label {
            min-width: 0;
            min-height: 30px;
            margin-right: $dim-15;
            margin-bottom: $dim-15;
            padding: 0;
            vertical-align: top;
            display: inline-flex;
            align-items: center;
        }

        > ux-tag {
            margin-right: $dim-15;
            margin-bottom: $dim-15;
        }
    }

    &__results-container .ux-slider-pagination {
        @media only screen and (min-width: 568px) {
            display: none;
        }
    }

    &__results-container .ux-iws-teaser-page:first-of-type {
        .ux-iws-teaser-page__container {
            padding-top: 0;
        }
    }

    .ux-slider .ux-slider__inner-container.gr-8 {
        @media only screen and (min-width: 1024px) and (max-width: 1200px) {
            width: 50%;
        }
    }

    .ux-slider-slide .ux-iws-teaser-page__container,
    .ux-slider-slide .ux-iws-teaser-article__content-container {
        @media only screen and (max-width: 1023px) {
            padding-bottom: 0;
        }
    }

    .ux-slider-slide .ux-iws-teaser-page,
    .ux-slider-slide .ux-iws-teaser-article {
        @media only screen and (max-width: 1023px) {
            border: 0;
            padding-right: 15px;
            margin-bottom: 0;
        }
    }

    .ux-slider-slide .ux-iws-teaser-page,
    .ux-slider-slide .ux-iws-teaser-article {
        @media only screen and (min-width: 1024px) {
            margin-bottom: -10px;
        }
    }

    .gr-10,
    .gr-8 {
        @media only screen and (max-width: 767px) {
            padding-left: 30px;
            padding-right: 30px;
        }
    }

    ux-iws-load-more .ux-iws-load-more__loading {
        margin-top: 0;
    }
}
